import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Cookie / privacy consent banner (Germany/GDPR). Strictly-necessary storage only,
// so this is a notice + acknowledgement rather than a tracking opt-in.
const CookieNotice = () => {
    const { t } = useTranslation();
    const [ack, setAck] = useState(() => {
        try { return localStorage.getItem('cookie_ack') === '1'; } catch (e) { return false; }
    });
    if (ack) return null;
    const accept = () => {
        try { localStorage.setItem('cookie_ack', '1'); } catch (e) {}
        setAck(true);
    };
    return (
        <div style={{
            // z-index sits BELOW the cart offcanvas (1045), its backdrop (1040) and the
            // floating "View Cart" button (1050) so the banner never covers checkout controls.
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1035,
            background: '#1f2d3d', color: '#fff', padding: '12px 16px',
            display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 12,
            fontSize: 13
        }}>
            <span style={{ maxWidth: 520 }}>
                {t('footer.cookie_notice')}{' '}
                <Link to='/legal/privacy' style={{ color: '#e89a80' }}>{t('footer.cookie_privacy_link')}</Link>.
            </span>
            <button onClick={accept} className='btn btn-sm fw-bold' style={{ background: '#d97757', color: '#fff', border: 'none' }}>{t('footer.cookie_ack')}</button>
        </div>
    );
};

const Footer = () => {
    return (
        <>
            <div className='text-center py-3' style={{ fontSize: 13 }}>
                <Link to='/legal/impressum' className='nav-link-color'>Impressum</Link>
                {'  ·  '}
                <Link to='/legal/privacy' className='nav-link-color'>Datenschutz / Privacy</Link>
            </div>
            <CookieNotice />
        </>
    );
}

export default Footer;
